import React from 'react';
import styles from './ReportableStatusModal.module.scss';
import { SFButton, SFDialog } from 'sfui';
import {
  ReportableStatus,
  ReportableStatusValue
} from '../ReportableStatus/ReportableStatus';

export interface ReportableStatusModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  isSaveButtonDisabled?: boolean;
  status: ReportableStatusValue;
  onChange: (value: ReportableStatusValue) => void;
  onSave: () => void;
  onDiscard: () => void;
}

export const ReportableStatusModal = ({
  isOpen,
  isLoading,
  isSaveButtonDisabled,
  status,
  onChange,
  onSave,
  onDiscard
}: ReportableStatusModalProps): React.ReactElement<ReportableStatusModalProps> => {
  return (
    <SFDialog
      open={isOpen}
      PaperProps={{ className: styles.reportableStatusModal }}
    >
      <ReportableStatus
        status={status}
        onChange={(value) => {
          onChange(value);
        }}
      />
      <footer>
        <SFButton
          size="large"
          variant="text"
          sfColor="grey"
          onClick={onDiscard}
        >
          Discard
        </SFButton>
        <SFButton
          size="large"
          variant="contained"
          sfColor="blue"
          isLoading={isLoading}
          onClick={onSave}
          disabled={isSaveButtonDisabled}
        >
          Save Changes
        </SFButton>
      </footer>
    </SFDialog>
  );
};
